import axios from "axios";

import {
  expireSession,
  getRefreshToken,
  getToken,
  isSessionExpired,
  refreshAccessToken,
} from "./cmsAuth";

const cmsAxios = axios.create();

cmsAxios.interceptors.request.use(async (config) => {
  config.headers = config.headers || {};
  const existingAuthorization = config.headers?.Authorization;
  if (existingAuthorization) {
    const adminToken = getToken();
    config._cmsAdminRequest = Boolean(
      adminToken && existingAuthorization === `Bearer ${adminToken}`,
    );
    return config;
  }

  config._cmsAdminRequest = true;
  let token = getToken();
  if (!token && getRefreshToken()) {
    try {
      token = await refreshAccessToken();
    } catch (error) {
      if (isSessionExpired(error)) expireSession();
      throw error;
    }
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

cmsAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const request = error?.config;
    if (
      error?.response?.status !== 401
      || !request?._cmsAdminRequest
    ) {
      return Promise.reject(error);
    }

    if (request._cmsRetried) {
      expireSession();
      return Promise.reject(error);
    }

    request._cmsRetried = true;
    try {
      const token = await refreshAccessToken();
      request.headers = request.headers || {};
      request.headers.Authorization = `Bearer ${token}`;
      return cmsAxios(request);
    } catch (refreshError) {
      if (isSessionExpired(refreshError)) {
        expireSession();
        return Promise.reject(error);
      }
      return Promise.reject(refreshError);
    }
  },
);

export default cmsAxios;
